import React, { useState } from 'react';
import {Typography, Paper} from '@mui/material';
import Choice from './Choice';
import Answer from './Answer';
import Wrong from './Wrong';
import { useTranslation } from 'react-i18next';

const question = {
    de: "Was ist kein Warnsignal für psychische Belastungsfolgen?",
    pl: "Co nie jest sygnałem ostrzegawczym dla efektów stresu psychologicznego?",
    tr: "Psikolojik stres etkileri için bir uyarı sinyali olmayan nedir?",
    uk: "Що не є попереджувальним сигналом для впливу психологічного стресу?"
}
const options =[
    {
        value: {de: "Ängstlichkeit", pl: "Niepokój", tr: "Anksiyete", uk: "Тривога"},
        correct: false
    },
    {
        value: {de: "Frustration", pl: "Frustracja", tr: "Hayal kırıklığı", uk: "Розчарування"},
        correct: false
    },
    {
        value: {de: "Hunger", pl: "Głód", tr: "Açlık", uk: "Голод"},
        correct: true
    },
    {
        value: {de: "Gereiztheit", pl: "Drażliwość", tr: "Sinirlilik", uk: "Дратівливість"},
        correct: false
    },
]
const answer = {
    de: "Die Folgen von Belastungen können bei jedem Menschen ganz unterschiedlich sein, nicht jeder ist beispielsweise durch Stress und Zeitdruck gleichermaßen belastet. Manchmal kann übermäßiger Stress aber zu körperlichen Auswirkungen und zu Verhaltensänderungen bei Betroffenen führen. Neben Ängstlichkeit, Frustration und Gereiztheit können auch körperliche Beschwerden wie z.B Magenprobleme auftreten.  Wenn solche Warnsignale auftauchen, ist es wichtig, dies nicht zu ignorieren. Am besten sollte man sich an eine Vertrauensperson wenden. Ebenso ist es wichtig, mit dem / der Hausärzt*in über die gegebenen Warnsignale zu sprechen.",
    pl: "Konsekwencje stresu mogą być bardzo różne dla każdej osoby; nie każdy jest jednakowo obciążony stresem i presją czasu, na przykład. Czasami jednak nadmierny stres może prowadzić do skutków fizycznych i zmian zachowania u osób nim dotkniętych. Oprócz niepokoju, frustracji i drażliwości mogą pojawić się również dolegliwości fizyczne, takie jak problemy żołądkowe.  Kiedy pojawiają się takie znaki ostrzegawcze, ważne jest, aby nie ignorować. Najlepiej szukać pomocy u zaufanej osoby. Ważne jest również, aby porozmawiać z lekarzem rodzinnym o znakach ostrzegawczych.",
    tr: "Stresin sonuçları her kişi için çok farklı olabilir; örneğin herkes stres ve zaman baskısından eşit derecede etkilenmez. Ancak bazen aşırı stres, stresten etkilenen kişilerde fiziksel etkilere ve davranış değişikliklerine yol açabilir. Kaygı, hayal kırıklığı ve sinirliliğin yanı sıra mide sorunları gibi fiziksel şikayetler de ortaya çıkabilir.  Bu tür uyarı işaretleri ortaya çıktığında, bunu görmezden gelmemek önemlidir. En iyisi güvendiğiniz bir kişiden yardım almaktır. Uyarı işaretleri hakkında aile doktorunuzla konuşmanız da önemlidir.",
    uk: "Наслідки стресу можуть бути дуже різними для кожної людини; не всі однаково обтяжені стресом і дефіцитом часу, наприклад. Однак іноді надмірний стрес може призвести до фізичних наслідків і змін у поведінці тих, хто зазнає його впливу. Окрім тривоги, розчарування та дратівливості, можуть також виникати фізичні скарги, наприклад, проблеми зі шлунком.  Коли з'являються такі тривожні ознаки, важливо не ігнорувати їх. Найкраще звернутися за допомогою до довіреної особи. Також важливо поговорити про тривожні ознаки зі своїм сімейним лікарем."
}

export default function QuizOnboarding() {

    const {i18n} = useTranslation()

    const [answered, setAnswered] = useState("not");

    const translatedAnswer = answer[i18n.language]
    const translatedQuestion = question[i18n.language]

    const makeAnswered = (correct) => {
        if (correct) {
            setAnswered("correct");
        } else {
            setAnswered("wrong");
        }
    }

    const chooseContent = () => {
        if (answered === "not") {
            return <Choice options={options} makeAnswered={makeAnswered} lang={i18n.language}/>;
        } else if (answered === "correct") {
            return <Answer text={translatedAnswer} unanswer={() => setAnswered("not")}/>;
        } else if (answered === "wrong") {
            return <Wrong unanswer={() => setAnswered("not")} />
        } else {
            return null;
        }
    }

    return(
        <Paper
            sx={{
                // position: "absolute",
                padding: 1,
                height: "100%"
            }}
        >
            <Typography
                sx={{marginBottom: 2}}
            >{translatedQuestion}</Typography>
            {chooseContent()}
        </Paper>

    )
}